import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TeacherDashboard = ({ base_url }) => {
  const [users, setUsers] = useState([]);
  const [exams, setExams] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedExam, setSelectedExam] = useState('');
  const [deadlineDate, setDeadlineDate] = useState('');

  useEffect(() => {
    axios.get(`${base_url}/users`)
      .then(response => setUsers(response.data))
      .catch(error => console.error('Error fetching users:', error));

    axios.get(`${base_url}/exams`)
      .then(response => setExams(response.data))
      .catch(error => console.error('Error fetching exams:', error));
  }, [base_url]);

  const formatDateTime = (date) => {
    const d = new Date(date);
    return d.toISOString().slice(0, 19).replace('T', ' ');
  };

  const handleAssign = () => {
    if (selectedUser && selectedExam) {
      axios.post(`${base_url}/assignments`, {
        created_date: formatDateTime(new Date()),
        user_id: selectedUser,
        exam_id: selectedExam,
        deadline_date: deadlineDate ? deadlineDate : formatDateTime(new Date())
      })
      .then(() => {
        alert('Exam assigned successfully!');
        setSelectedUser('');
        setSelectedExam('');
        setDeadlineDate('');
      })
      .catch(error => console.error('Error assigning exam:', error));
    } else {
      alert('Please select a user, an exam, and a deadline date.');
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-8 bg-white shadow-lg rounded-xl mt-10">
      <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">Teacher Dashboard</h1>
      <div className="mb-6">
        <label className="block mb-2 text-lg font-medium text-gray-700">Select User:</label>
        <select
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300"
        >
          <option value="">-- Select User --</option>
          {users.map(user => (
            <option key={user.user_id} value={user.user_id}>
              {user.full_name}
            </option>
          ))}
        </select>
      </div>
      <div className="mb-6">
        <label className="block mb-2 text-lg font-medium text-gray-700">Select Exam:</label>
        <select
          value={selectedExam}
          onChange={(e) => setSelectedExam(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300"
        >
          <option value="">-- Select Exam --</option>
          {exams.map(exam => (
            <option key={exam.id} value={exam.id}>
              Exam ID: {exam.id}
            </option>
          ))}
        </select>
      </div>
      <div className="mb-6">
        <label className="block mb-2 text-lg font-medium text-gray-700">Select Deadline Date:</label>
        <input
          type="date"
          value={deadlineDate}
          onChange={(e) => setDeadlineDate(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300"
        />
      </div>
      <button
        onClick={handleAssign}
        className="w-full p-3 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 transition duration-300 shadow-md"
      >
        Assign Exam
      </button>
    </div>
  );
};

export default TeacherDashboard;
